

<script>

export default {
  name: 'customPElement',
  props: ['text', 'refFinal', 'references'],
  data: function (){
    return {
      elements: ['span', {}, []]
    }
  },
  render: function(h) {
    return (this.parseTextData(this.text, h))
  },
  methods : {
    parseTextData: function(text, h) {
      if (text) {
        let vm = this
        let finalText = text.split(/(\[[\da-fA-F]{40}\])/gim)
        let result = []
        for (let arrayIndex = 0; arrayIndex < finalText.length; arrayIndex++) {
          let currentText = finalText[arrayIndex]
          if (currentText && currentText.match(/\[[\da-fA-F]{40}\]/gim) && currentText.match(/\[[\da-fA-F]{40}\]/gim).length) {
            const auxRefFinal = vm.refFinal.map((ref) => { return ref.id})
            let cleanRef = finalText[arrayIndex].replace(/[\[\]']+/g, '')
            let index = auxRefFinal.indexOf(cleanRef)
            if (index > -1) {
              let citation_splitted = vm.refFinal[index].citation.split('.')
              let author = citation_splitted[0].split(',')[0]
              let year = citation_splitted.filter(word => word.includes(';'))[0].slice(0,5)
              // return ('['+(vm.references.indexOf(x) + 1).toString()+']')
              result.push(
                <span> 
                  <a href={'#'+cleanRef} id={'tooltip-'+cleanRef+'-'+arrayIndex.toString()}>
                    {"[" + vm.refFinal[index].authors[0] + ', '+ vm.refFinal[index].year.toString() + "]"} 
                  </a>
                  <b-tooltip target={'tooltip-'+cleanRef+'-'+arrayIndex.toString()} triggers="hover">
                    { vm.refFinal[index].citation }
                  </b-tooltip>
                </span>
              )
            } else {
              result.push(
                <span> 
                  {currentText}
                </span>
              )
            }
          } else {
            let newFinalText = currentText.split(/(\[.*?\]\(.*?\))/gim)
            for (let newArrayIndex = 0; newArrayIndex < newFinalText.length; newArrayIndex++) {
              let newCurrentText = newFinalText[newArrayIndex]
              if (newCurrentText && newCurrentText.match(/\[(.*?)\]\((.*?)\)/gim) && newCurrentText.match(/\[(.*?)\]\((.*?)\)/gim).length) {
                let links = newCurrentText.split(/\[(.*?)\]\((.*?)\)/gim)
                result.push(
                  <a href={links[2]}> 
                    {links[1]}
                  </a>
                )
              }
              else {
                result.push(
                  <span>
                    {newFinalText[newArrayIndex]}
                  </span>
                )
              }
            }
          }
        }
          // .replace(/\[(.*?)\]\((.*?)\)/gim, function(linkText, link) {return (<a href={link}>{ linkText }</a>)})
        return (<p> {result} </p>)
      } else{
        return (<p> </p>)
      }
    }
  },
  mounted: function() {
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/styles/variables.scss";
  p {
    font-size: 14px;
  }
  .lsr-container {
    h1 {
      font-size: 1.7em;
    }
    h2 {
      font-size: 1.2em;
    }
    h3 {
      font-size: 1.1em;
    }

    .header {
      margin-bottom: 2em;
      h1 {
        font-weight: bold;
        margin-top: 0.3em;
        margin-bottom: 1em;
      }
      .publication-type {
        font-weight: bold;
        font-size: 0.9em;
      }
      .authors, .dates {

      }
    }

    .tab_content {
      .languages {
        margin-bottom: 2em;
      }
      h1:not(:first-child) {
        margin-top: 1.8em;
      }
      h2 {
        font-weight: bold;
        &:not(:first-child) {
          margin-top: 1.4em;
        }
      }
      h3 {
        font-style: italic;
        &:not(:first-child) {
          margin-top: 1.2em;
        }
      }
      ul.arrow {
        margin-inline-start: 1.5em;
        // li:before {
        //   font-family: 'FontAwesome';
        //   content: '\f061'
        // }
      }
    }

    .image {
      max-width: 100%;
    }
    .isof {
      min-width: 801px;
      min-height: 600px;
    }
  }
</style>

<style>
    .ctooltip {
  cursor: pointer;
  position: relative;
  display: inline-block;
  visibility: visible;
  border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
}

/* Tooltip text */
.ctooltip .tooltiptext {
  visibility: hidden;
  background-color: #000;
  color: #fff;
  width: 25vw;
  max-width: 600px;
  text-align: center;
  padding: .25rem .5rem;
  border-radius: .25rem;
  position: absolute;
  z-index: 100;
  bottom: 110%;
  left: 50%;
  transform:translate(-50%,0%);
  opacity: 0;
  transition: 0.3s opacity;
  font-size: 0.875rem;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  line-height: 1.5;
  word-wrap: break-word;
}

.ctooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: calc(50% - 10px);;
  margin: 0 .25rem;
  border-width: .4rem;
  border-style: solid;
  border-color: #000 transparent transparent transparent;
}

.ctooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
  display: inline-block;
}

html {
  scroll-behavior: smooth;
}

</style>
